export const mapTestimonialsToImage = (names, assets) =>
	names.map(name => ({
		key: name,
		image: assets.find(asset => asset.title.toLowerCase().includes(`${name} portret`))?.gatsbyImageData,
	}))
